const profileSections = {
  ABOUT: 'about',
  CONTACT: 'contact',
  HOURS: 'hours',
  LOGO: 'logo',
  PHOTOS: 'photos',
  LICENSING: 'licensing',
  SERVICE_DETAILS: 'serviceDetails',
  SHOWCASE: 'showcase',
};

export default profileSections;



// WEBPACK FOOTER //
// ./src/modules/profile/common/profileSections.js